import { render, staticRenderFns } from "./JdsTextAreaField.vue?vue&type=template&id=ab66a292&scoped=true&"
import script from "./JdsTextAreaField.vue?vue&type=script&lang=ts&"
export * from "./JdsTextAreaField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab66a292",
  null
  
)

export default component.exports